import { render, staticRenderFns } from "./ResetPasswordStudent.vue?vue&type=template&id=932f5406&"
import script from "./ResetPasswordStudent.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports